import React from 'react';
import { styled } from '@mui/material/styles';
import 'date-fns';
import Grid from '@mui/material/Grid';
import 'date-fns';
import Button from '@mui/material/Button';
import ChooseDevices from './ChooseDevicesUpdated';
import Icon from '@mui/material/Icon';
import BaseLayout from 'views/BaseLayout';
import { ToastsStore } from 'react-toasts';
import AdvertisementCardGrid from './AdvertisementCardGrid';
import { CampaignAdvertisement } from '@horasys/bellplus/common/types';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import { ADD_CAMPAIGN_ADVERTISEMENT, CampaignState, RESET_CAMPAIGN_ADVERTISEMENT_FORM, RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE, UPDATE_CAMPAIGN_ADVERTISEMENT_FORM, UPDATE_CAMPAIGN_AD_UI_STATE, deleteCampaignAdvertisement } from 'Stores/Slices/campaignSlice';
import { RootState } from 'Stores/store';
import { AdvertisementState } from 'Stores/Slices/advertisementSlice';
const PREFIX = 'CampaignAdvertisementView';

const classes = {
    formElement: `${PREFIX}-formElement`,
    paperchildGrid: `${PREFIX}-paperchildGrid`,
    saveGrid: `${PREFIX}-saveGrid`
};
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.formElement}`]: {
        minWidth: '100%',
        marginTop: theme.spacing(3),
    },

    [`& .${classes.paperchildGrid}`]: {
        padding: theme.spacing(2),
    },

    [`& .${classes.saveGrid}`]: {
        paddingBottom: theme.spacing(2),
    }
}));

interface Props {
	handleNext: any;
	handleBack: any;
}
const CampaignAdvertisementView = (props: Props) => {
	const { handleNext, handleBack } = props;
	const campaignStore: CampaignState = useAppSelector((state: RootState) => state.campaign);
	const {
		campaignAdvertisementForm: advFormData,
		campaignAdvertisementState,
		campaign,
	} = campaignStore;

	const { isChooseDevicesPopupOpen: isOpenModal } = campaignAdvertisementState;

	const dispatch = useAppDispatch();
	const modelCloseHandler = () => {
		dispatch(
			UPDATE_CAMPAIGN_AD_UI_STATE({
				isChooseDevicesPopupOpen: false,
				isChooseDevicesViewMode: false,
			}),
		);
		dispatch(RESET_CAMPAIGN_ADVERTISEMENT_UI_STATE(null));
	};

	const handleAddAdvertisement = () => {
		dispatch(
			UPDATE_CAMPAIGN_AD_UI_STATE({
				isChooseDevicesPopupOpen: true,
				isChooseDevicesViewMode: false,
			}),
		);
	};

	const handleEditAdvertisement = (index: any) => {
		dispatch(
			UPDATE_CAMPAIGN_ADVERTISEMENT_FORM(campaign.campaignAdvertisements[index]),
		);

		dispatch(
			UPDATE_CAMPAIGN_AD_UI_STATE({
				isChooseDevicesPopupOpen: true,
				isChooseDevicesViewMode: false,
			}),
		);
	};

	const handleViewAdvertisement = (index: any) => {
		dispatch(
			UPDATE_CAMPAIGN_ADVERTISEMENT_FORM(campaign.campaignAdvertisements[index]),
		);

		dispatch(
			UPDATE_CAMPAIGN_AD_UI_STATE({
				isChooseDevicesPopupOpen: true,
				isChooseDevicesViewMode: true,
			}),
		);
	};

	const advertisementStore: AdvertisementState = useAppSelector(
		(state: RootState) => state.advertisement,
	);
	const { list: advertisementList } = advertisementStore;

	const resetAdvFormData = () => {
		dispatch(RESET_CAMPAIGN_ADVERTISEMENT_FORM(null));
	};

	const handleSubmit = (event: any) => {
		event.preventDefault();
		if (campaign.campaignAdvertisements.length > 0) {
			handleNext();
		} else {
			ToastsStore.error('Atleast add one advertisement to continue', 8000);
		}
	};

	const addAdvertisementHandler = async (result: CampaignAdvertisement) => {
		dispatch(ADD_CAMPAIGN_ADVERTISEMENT(null));
		resetAdvFormData();
	};

	const handleDeleteAdvertisement = async (index: any) => {
		const result = campaign.campaignAdvertisements[index];
		dispatch(deleteCampaignAdvertisement(index, result.uuid));
	};

	return (
        <Root>
            <BaseLayout>
                <div className={classes.paperchildGrid}>
                    <Grid container xs={12} direction="row">
                        <Grid item container xs={12}>
                            <AdvertisementCardGrid
                                handleDeleteAdvertisement={handleDeleteAdvertisement}
                                handleViewAdvertisement={handleViewAdvertisement}
                                handleEditAdvertisement={handleEditAdvertisement}
                                handleAddAdvertisement={handleAddAdvertisement}
                            />
                        </Grid>
                    </Grid>
                </div>

                <ChooseDevices
                    advertisementList={advertisementList}
                    isOpenModel={isOpenModal}
                    closeHandler={modelCloseHandler}
                    advFormData={advFormData}
                    handleAdSubmitHandler={addAdvertisementHandler}
                />
                <Grid
                    container
                    item
                    direction="row"
                    justifyContent="space-around"
                    className={classes.saveGrid}>
                    <Grid item>
                        <Button className={classes.formElement} onClick={handleBack} style={{color:'#042630'}}>
                            BACK
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            className={classes.formElement}
                            style={{backgroundColor:'#042630'}}
                            variant="contained"
                            onClick={handleSubmit}
                            color="primary"
                            endIcon={<Icon>send</Icon>}>
                            Next
                        </Button>
                    </Grid>
                </Grid>
            </BaseLayout>
        </Root>
    );
};

//#endregion

export default CampaignAdvertisementView;
